import * as React from 'react';

function Svg24Copy( props ){
  return (
    <svg
      width={ 24 }
      height={ 24 }
      { ...props }
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.574 3.809v.936h3.745a.93.93 0 0 1 .936.936v2.808h.936V5.681a1.88 1.88 0 0 0-1.872-1.872zM2.872 3.809A1.88 1.88 0 0 0 1 5.68v15.447A1.88 1.88 0 0 0 2.872 23H8.49v-.936H2.872a.93.93 0 0 1-.936-.936V5.68a.93.93 0 0 1 .936-.936h3.745v-.936z'
        color='#000'
        fill='#000'
        strokeWidth={ 0 }
        strokeDasharray='none'
      />
      <path
        d='M6.655 1c-.785 0-1.36.797-1.11 1.541l.937 2.809c.159.476.608.799 1.11.799H13.6c.502 0 .95-.323 1.11-.8l.936-2.808C15.896 1.797 15.32 1 14.536 1H6.657Zm-.001.936h7.884c.173 0 .276.143.221.307v.002l-.936 2.809a.23.23 0 0 1-.223.159H7.592a.23.23 0 0 1-.224-.16l-.936-2.808v-.002c-.055-.164.048-.307.222-.307zM12.702 10.83c-1.03 0-1.872.843-1.872 1.872v8.426c0 1.029.843 1.872 1.872 1.872h8.426C22.157 23 23 22.157 23 21.128v-8.426c0-1.029-.843-1.872-1.872-1.872zm0 .936h8.426c.526 0 .936.41.936.936v8.426c0 .526-.41.936-.936.936h-8.426a.924.924 0 0 1-.936-.936v-8.426c0-.527.41-.936.936-.936z'
        color='#000'
        fill='#000'
        strokeWidth={ 0 }
        strokeDasharray='none'
      />
      <path
        d='M14.106 13.638v.936h5.617v-.936ZM14.106 16.447v.936h5.617v-.936ZM14.106 19.255v.936h2.107v-.936z'
        color='#000'
        fill='#000'
        strokeWidth={ 0 }
        strokeDasharray='none'
      />
    </svg>
  );
}

export default Svg24Copy;
